import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_ERROR_INVOKED_SCHEMA = Object.freeze({
  ERROR_TYPE: '',
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_ERROR_INVOKED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_ERROR_INVOKED_SCHEMA);

export class ErrorInvokedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.error_invoked;
  }

  get properties() {
    return this.toJS();
  }
}
